import "./Home.css";
import Slideshow from "../common-components/Slideshow";
import LearnerCarouselNew from "../common-components/LearnerCarouselNew";
import HangingMenus from "../common-components/HangingMenus";
const Home = () => {
  return (
    <>
      <div className="bannerContainer">
        <Slideshow />
      </div>

      <div className="platform">
        <div className="container">
          <div className="platform_text">
            <h2>Platforms</h2>
          </div>
          <div className="platform_blocks">
            <div className="sap">
              <div className="platform_header">
                <h5>SAP</h5>
              </div>
              <div className="imageWrap1 platform-img-zoom-box">
                <a href="/SAPAcademy/Courses" target="_blank">
                  <img
                    src="images/home/platform/sap.png"
                    alt="SAP"
                    className="platform-img-zoom img-responsive"
                  />
                </a>
              </div>
              <div className="platform-block-content">
                <p className="platform-block-content-para">
                  Explore how you can boost your SAP career through L&TT SAP
                  experiential job-ready learnings that’s tailor-made for you
                  and excel at client delivery.
                </p>
              </div>
              <div className="link">
                <a
                  href="/SAPAcademy/Courses"
                  target="_blank"
                  className="platform_read_more"
                >
                  Explore
                </a>
              </div>
            </div>
            <div className="oracle">
              <div className="platform_header">
                <h5>Oracle</h5>
              </div>
              <div className="imageWrap1 platform-img-zoom-box">
                <a href="/Oracle/Courses" target="_blank">
                  <img
                    src="images/home/platform/oracle.png"
                    alt="Orcale"
                    className="platform-img-zoom img-responsive"
                  />
                </a>
              </div>
              <div className="platform-block-content">
                <p className="platform-block-content-para">
                  Explore here to amplify your skills on Oracle career through
                  L&TT Oracle experiential job-ready learnings that’s customized
                  for you to excel at client delivery.
                </p>
              </div>
              <div className="link">
                <a
                  href="/Oracle/Courses"
                  target="_blank"
                  className="platform_read_more"
                >
                  Explore
                </a>
              </div>
            </div>
            <div className="salesforce">
              <div className="platform_header">
                <h5>Salesforce</h5>
              </div>
              <div className="imageWrap1 platform-img-zoom-box">
                <a href="/Salesforce/Courses" target="_blank">
                  <img
                    src="images/home/platform/salesforce.png"
                    alt="Salesforce"
                    className="platform-img-zoom img-responsive"
                  />
                </a>
              </div>
              <div className="platform-block-content">
                <p className="platform-block-content-para">
                  Salesforce is industry-leading CRM and platform service
                  provider in cloud to deliver exceptional services and products
                  at very competitive prices. The products it offers include
                  sales, marketing, service, analytics, commerce, app, IoT,
                  financial services, health services all functions on cloud
                  platform.
                </p>
              </div>
              <div className="link">
                <a
                  href="/Salesforce/Courses"
                  target="_blank"
                  className="platform_read_more"
                >
                  Explore
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about_us">
        <div className="container about_us">
          <div className="about_us_text">
            <h2 className="about_us_text_head">About us</h2>
            <p className="container_para">
              Enterprise Platforms is a learning forum offering deep insights
              into SAP, Oracle, Salesforce, and Workday. It investigates the
              industry requirements and market demands for new technologies and
              offers invaluable learning paths in the above four platforms.
              Enterprise Platforms has been designed to fulfill your learning
              needs of all Enterprise Platforms skills, including the emerging
              areas on core platforms, Cloud, Digital, Security, IoT, and
              Automation.
            </p>
          </div>
          {/* <div className="about_us_video">
            <img src="images/home/Video.png" alt="About Us Video" className="about_us_video_img" />
          </div> */}
        </div>
      </div>
      {/* <div className="about_us">
        <div className="container about_us">
          <div className="about_us_text">
            <h2 className="about_us_text_head">About us</h2>
            <p className="container_para">
              Enterprise Platforms is a learning forum offering deep insights into SAP, Oracle, Salesforce, and Workday. It
              investigates the industry requirements and market demands for new technologies and offers invaluable
              learning paths in the above four platforms. Enterprise Platforms has been designed to fulfill your learning needs
              of all Enterprise Platforms skills, including the emerging areas on core platforms, Cloud, Digital, Security, IoT, and
              Automation.
            </p>
          </div>
          <div className="about_us_video">
            <img src="images/home/Video.png" alt="About Us Video" className="about_us_video_img" />
          </div>
        </div>
      </div>       */}
      <div className="leader">
        <div className="container">
          <h2 className="leader-header">Know Your Leads</h2>
          <div className="leader-content">
            {/* <img src="images/home/ldr1.png" className="leader1-img" alt="" />
            <img src="images/home/ldr2.png" className="leader1-img" alt="" /> */}
            <div className="leader1">
              <div className="leader-data">
                <img
                  src="images/home/leader_1.png"
                  className="leader1-img"
                  alt=""
                />
                <h3 className="name">Ambrish Rastogi</h3>
                <h5 className="designation">
                  {/* Lead – Learning & Leadership Development, ATC-GN */}
                  Managing Director, Lead - Learning and Talent Transformation Advanced Technology Centers in India
                </h5>{" "}
                <br />
              </div>

              <p>
                Learning as we all know is central to our business. We endeavor
                to provide curated learnings which are aligned to the needs of
                the role / client and are constantly updated with the latest and
                greatest to keep pace with the ever changing technology
                landscape. Our E&IT Academy is a great example of this. It
                caters to learning needs for Platforms like SAP, Salesforce and
                Oracle and stands as a testament to our commitment to continuous
                learning. It is carefully designed and built to provide an
                engaging learning experience. Let's make the most of this
                platform. Wishing you a fulfilling and enlightening learning
                experience.
              </p>
            </div>
            <div className="leader2">
              <div className="leader-data">
                <img
                  src="images/home/leader_2.png"
                  className="leader1-img"
                  alt=""
                />
                <h3 className="name">Praveen Rajaram</h3>
                <h5 className="designation">
                  {/* Lead, Enterprise Platforms, Learning & Talent Transformation,
                  ATCI */}
                  Managing Director, Lead - Learning and Talent Transformation Advanced Technology Centers in India
                </h5>{" "}
                <br />
              </div>

              <p>
                Enterprise Platforms is one of the largest, most important
                growth areas for Accenture and aims to deliver tangible value at
                the most incredible speed in the market. L&TT identifies the
                latest industry requirements for new technologies and offers
                invaluable learnings in SAP, Oracle, and Salesforce aimed to
                address both the business needs and learners’ aspirations. At
                L&TT, our constant endeavor is to provide diverse comprehensive
                learnings in a bite-sized and blended manner, to make a
                significant impact on your job assignments. Come, and experience
                the Enterprise Platforms portal, a one-stop destination to
                fulfill your learning quest!
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="learner">
        <div className="container">
          <div className="learner-header1">
            <h2>Learners' Stories</h2>
          </div>
          <LearnerCarouselNew />
        </div>
      </div>
      <HangingMenus />
    </>
  );
};

export default Home;
